/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pie_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many slices should I use?`)
};

const es_pie_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuántas porciones debería usar?`)
};

const de_pie_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele Segmente sollte ich verwenden?`)
};

const nl_pie_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveel segmenten moet ik gebruiken?`)
};

const fr_pie_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de secteurs dois-je utiliser ?`)
};

const it_pie_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quante fette dovrei usare?`)
};

const pt_br2_pie_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantas fatias devo usar?`)
};

const pt_pie_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantas fatias devo usar?`)
};

const ja_pie_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スライスはいくつまでにすべきですか？`)
};

const zh_pie_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应该使用多少个扇形？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pie_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pie_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pie_faq_q3", locale)
	if (locale === "en") return en_pie_faq_q3(inputs)
	if (locale === "es") return es_pie_faq_q3(inputs)
	if (locale === "de") return de_pie_faq_q3(inputs)
	if (locale === "nl") return nl_pie_faq_q3(inputs)
	if (locale === "fr") return fr_pie_faq_q3(inputs)
	if (locale === "it") return it_pie_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_pie_faq_q3(inputs)
	if (locale === "pt") return pt_pie_faq_q3(inputs)
	if (locale === "ja") return ja_pie_faq_q3(inputs)
	return zh_pie_faq_q3(inputs)
};